import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { head } from 'lodash';

import { ModalCard } from 'partial/components/Modal';
import AsyncButton from 'modules/common/components/AsyncButton';
import FormPassword from 'partial/components/form/FormPassword';

import { useDeleteUser } from '../hooks';

const DeleteUser = ({ onClose, uuid, users }) => {
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const { values, setFieldValue } = useFormik({
    initialValues: {
      password_confirmation: '',
    },
  });

  const filterUsers = useMemo(
    () => users?.filter((item) => item?.uuid !== uuid),
    [users, uuid],
  );

  const onError = () => setPending(false);

  const onSuccess = () => {
    setPending(false);
    navigate(`/access-control/user-management/${head(filterUsers)?.uuid}`);
    onClose();
  };

  const [isLoading, deleteUser] = useDeleteUser(onSuccess, onError);

  const handlDeleteUser = () => {
    setPending(true);
    deleteUser({
      id: uuid,
      password_confirmation: values?.password_confirmation,
    });
  };

  return (
    <ModalCard size="sm" title="CONFIRM DELETION" onClose={onClose}>
      <div className="p-4 pt-2">
        <h5 className="pb-10 font-light">
          Please enter your password to continue.
        </h5>
        <FormPassword
          name="password_confirmation"
          value={values?.password_confirmation}
          onSetFieldValue={setFieldValue}
        />

        <div className="flex justify-end gap-2 pt-8 border-neutral-200">
          <AsyncButton
            className="font-[400] !text-neutral-500"
            color="outline"
            onClick={onClose}
          >
            Cancel
          </AsyncButton>
          <AsyncButton
            type="button"
            onClick={handlDeleteUser}
            className="font-[400]"
            color="outline"
            disabled={!values?.password_confirmation?.length}
            isLoading={pending || isLoading}
          >
            confirm
          </AsyncButton>
        </div>
      </div>
    </ModalCard>
  );
};

DeleteUser.propTypes = {
  uuid: PropTypes.string.isRequired,
  users: PropTypes.instanceOf(Array).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteUser;
